// The country picker on sign-up. The server accepts any ISO 3166-1 alpha-2 code,
// so the list is every officially assigned one; the NAMES come from the browser
// (Intl.DisplayNames) in the reader's language, so no name table is shipped.
const CODES =
  "AD AE AF AG AI AL AM AO AQ AR AS AT AU AW AX AZ BA BB BD BE BF BG BH BI BJ BL BM BN BO BQ BR BS BT BV BW BY BZ " +
  "CA CC CD CF CG CH CI CK CL CM CN CO CR CU CV CW CX CY CZ DE DJ DK DM DO DZ EC EE EG EH ER ES ET FI FJ FK FM FO FR " +
  "GA GB GD GE GF GG GH GI GL GM GN GP GQ GR GS GT GU GW GY HK HM HN HR HT HU ID IE IL IM IN IO IQ IR IS IT JE JM JO " +
  "JP KE KG KH KI KM KN KP KR KW KY KZ LA LB LC LI LK LR LS LT LU LV LY MA MC MD ME MF MG MH MK ML MM MN MO MP MQ MR " +
  "MS MT MU MV MW MX MY MZ NA NC NE NF NG NI NL NO NP NR NU NZ OM PA PE PF PG PH PK PL PM PN PR PS PT PW PY QA RE RO " +
  "RS RU RW SA SB SC SD SE SG SH SI SJ SK SL SM SN SO SR SS ST SV SX SY SZ TC TD TF TG TH TJ TK TL TM TN TO TR TT TV " +
  "TW TZ UA UG UM US UY UZ VA VC VE VG VI VN VU WF WS YE YT ZA ZM ZW";

export type Country = { code: string; name: string };

export function countryOptions(locale: string | undefined): Country[] {
  const names = new Intl.DisplayNames(locale ? [locale] : undefined, { type: "region" });
  const collator = new Intl.Collator(locale);
  return CODES.split(" ")
    .map((code) => ({ code, name: names.of(code) ?? code }))
    .sort((a, b) => collator.compare(a.name, b.name));
}

/** The country in the browser's own language tag ("hu-HU" → "HU"), else the fallback. */
export function browserCountry(languages: readonly string[] | undefined, fallback: string): string {
  for (const tag of languages ?? []) {
    const region = tag.split("-")[1]?.toUpperCase();
    if (region && CODES.includes(region) && /^[A-Z]{2}$/.test(region)) return region;
  }
  return fallback;
}
